export default __webpack_public_path__ + "static/media/image_placeholder.70f0d297.png";